module.exports = "<div mat-dialog-content>\n  <div>\n    <img src=\"../../assets/newImages/corona_banner.jpg\" alt=\"Corona ALert\" style=\"width: 100%\">\n  </div>\n</div>\n<div mat-dialog-actions class=\"pull-right\">\n  <button  mat-button (click)=\"closeDialog()\"><i class=\"fa fa-times fa-2x\" aria-hidden=\"true\"></i></button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/corona.component.html
// module id = ./src/app/home/corona.component.html
// module chunks = main